import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CompetitorRun, CreateCompetitorRunRequest } from '@seo/types';
import { apiPost } from '@/lib/api';

export function useCreateCompetitorRun() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateCompetitorRunRequest) =>
      apiPost<CompetitorRun>('/v1/competitor-runs', input, {
        headers: { 'idempotency-key': crypto.randomUUID() },
      }),
    onSuccess: (run) => {
      void qc.invalidateQueries({ queryKey: ['competitor-runs'] });
      qc.setQueryData(['competitor-run', run.id], run);
    },
  });
}
